var LinearVelocityUnit_1;
import { __decorate } from "tslib";
import { SerializableObject } from '../../data/decorators';
import { DerivedUnit } from './DerivedUnit';
import { LengthUnit } from './LengthUnit';
import { TimeUnit } from './TimeUnit';
/**
 * @category Unit
 */
let LinearVelocityUnit = LinearVelocityUnit_1 = class LinearVelocityUnit extends DerivedUnit {};
LinearVelocityUnit.METER_PER_SECOND = new LinearVelocityUnit_1('meter per second', {
  baseName: 'linearvelocity',
  aliases: ['m/s', 'meters per second']
}).addUnit(LengthUnit.METER, 1).addUnit(TimeUnit.SECOND, -1);
LinearVelocityUnit.CENTIMETER_PER_SECOND = LinearVelocityUnit_1.METER_PER_SECOND.swap([LengthUnit.CENTIMETER], {
  baseName: 'linearvelocity',
  name: 'centimeter per minute',
  aliases: ['cm/min', 'centimeters per minute']
});
LinearVelocityUnit = LinearVelocityUnit_1 = __decorate([SerializableObject()], LinearVelocityUnit);
export { LinearVelocityUnit };